<template>
  <div>
    <a @click="Delete">ユーザー退会</a>
  </div>
</template>

<script>
// API
import API from "@/API";
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  name: "DeleteUser",
  setup() {
    const store = useStore();
    const route = useRoute();

    // onMounted(async () => {
    //   if(route.query.id){
    //     store.commit("presetTokens/setIDToken", route.query.id)
    //     store.commit("presetTokens/setAccessToken", route.query.access)
    //   }
    //   // Myチケット取得(未使用)
    // });
    const Delete = async () => {
      await API.deleteUser();
    };

    return {
      Delete,
    };
  },
};
</script>
<style scoped>
a {
  padding: 10px 20px;
  margin: 50px auto;
  display: block;
  background: darkgray;
  color: white;
  /* box-shadow: 1px 1px 1px black; */
  text-align: center;
  width: 80%;
  border: 2px solid black;
}
</style>
